import { useEffect, useRef } from "react";

export default function CursorGlow() {
  const dot = useRef(null);
  const ring = useRef(null);

  useEffect(() => {
    const isTouch = window.matchMedia("(pointer: coarse)").matches;
    if (isTouch) return;

    let dx = 0, dy = 0, rx = 0, ry = 0;
    let mouseX = -100, mouseY = -100;

    const onMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    const tick = () => {
      dx += (mouseX - dx) * 0.5;
      dy += (mouseY - dy) * 0.5;
      rx += (mouseX - rx) * 0.14;
      ry += (mouseY - ry) * 0.14;
      if (dot.current) dot.current.style.transform = `translate3d(${dx - 4}px, ${dy - 4}px, 0)`;
      if (ring.current) ring.current.style.transform = `translate3d(${rx - 18}px, ${ry - 18}px, 0)`;
      raf = requestAnimationFrame(tick);
    };
    let raf = requestAnimationFrame(tick);
    window.addEventListener("mousemove", onMove);
    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
    // Mount-only: dot/ring are refs (stable). All other names are local to the effect.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div ref={ring} className="cursor-ring hidden md:block" aria-hidden="true" />
      <div ref={dot} className="cursor-dot hidden md:block" aria-hidden="true" />
    </>
  );
}
